/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { ITrand } from './Trand';

export interface IGetSupplyDemandResponse {
  /** Данные для вывода графика спроса **/
  demandTrand: ITrand[];
  /** Данные для вывода графика предложения **/
  supplyTrand: ITrand[];
  /** Разница в процентах для спроса **/
  demandDiff?: TGetSupplyDemandResponse_DemandDiff;
  /** Тренд изменения спроса рост/падение/без изменения **/
  demandDiffTrand?: TGetSupplyDemandResponse_DemandDiffTrand;
  /** Разница в процентах для предложения **/
  supplyDiff?: TGetSupplyDemandResponse_SupplyDiff;
  /** Тренд изменения предложения рост/падение/без изменения **/
  supplyDiffTrand?: TGetSupplyDemandResponse_SupplyDiffTrand;
  /** Название типа рынка **/
  marketType?: TGetSupplyDemandResponse_MarketType;
  /** Подробное описание того что происходит с рынком **/
  marketTypeDescription?: TGetSupplyDemandResponse_MarketTypeDescription;
}

export type TGetSupplyDemandResponse_DemandDiff = null | string;

export type TGetSupplyDemandResponse_DemandDiffTrand = null | EDemandDiffTrand;

export enum EDemandDiffTrand {
  /** Цена увеличилась **/
  'Increase' = 'increase',
  /** Цена уменьшилась **/
  'Decrease' = 'decrease',
  /** Цена не изменилась **/
  'NoChange' = 'noChange',
}
export type TGetSupplyDemandResponse_SupplyDiff = null | string;

export type TGetSupplyDemandResponse_SupplyDiffTrand = null | ESupplyDiffTrand;

export enum ESupplyDiffTrand {
  /** Цена увеличилась **/
  'Increase' = 'increase',
  /** Цена уменьшилась **/
  'Decrease' = 'decrease',
  /** Цена не изменилась **/
  'NoChange' = 'noChange',
}
export type TGetSupplyDemandResponse_MarketType = null | EMarketType;

export enum EMarketType {
  /** Растущий рынок **/
  'Растущий рынок' = 'Растущий рынок',
  /** Падающий рынок **/
  'Падающий рынок' = 'Падающий рынок',
  /** Рынок замер **/
  'Рынок замер' = 'Рынок замер',
  /** Рынок продавца **/
  'Рынок продавца' = 'Рынок продавца',
  /** Рынок покупателя **/
  'Рынок покупателя' = 'Рынок покупателя',
  /** Нет отрисовки **/
  'Нет отрисовки' = 'нет отрисовки',
}
export type TGetSupplyDemandResponse_MarketTypeDescription = null | string;
